import React from 'react'
import Column from './Column'
import './todo.scss';

const Todo = ({ name, stage, projects, height, maxHeight, isCreateCardFieldOpen, handleCreateCardClick, boardName }) => {
  return (
    <>
      <Column name={name} stage={stage} cards={projects} height={height} maxHeight={maxHeight} isCreateCardFieldOpen={isCreateCardFieldOpen} handleCreateCardClick={handleCreateCardClick} boardName={boardName} />
    </>
  );
};

const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.name === nextProps.name &&
    prevProps.stage === nextProps.stage &&
    prevProps.projects === nextProps.projects &&
    prevProps.height === nextProps.height &&
    prevProps.maxHeight === nextProps.maxHeight
  );
};

export default React.memo(Todo, areEqual);